export type ClientDateTimeContext = {
  clientLocalTime: string;
  timezone: string;
};

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

/** Local wall-clock time with numeric UTC offset, e.g. 2026-06-05T14:30:45+02:00 */
export function formatLocalIsoWithOffset(date: Date): string {
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMinutes);
  const offsetHour = pad(Math.floor(abs / 60));
  const offsetMinute = pad(abs % 60);

  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}` +
    `${sign}${offsetHour}:${offsetMinute}`
  );
}

export function getClientDateTimeContext(now = new Date()): ClientDateTimeContext {
  return {
    clientLocalTime: formatLocalIsoWithOffset(now),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}
